__turbopack_context__.v({
  "gridColumnsLeft": "CalculatorStyles-module-scss-module__JS2sga__gridColumnsLeft",
  "gridColumnsRight": "CalculatorStyles-module-scss-module__JS2sga__gridColumnsRight",
  "textInfoContainer": "CalculatorStyles-module-scss-module__JS2sga__textInfoContainer",
  "textWithTooltip": "CalculatorStyles-module-scss-module__JS2sga__textWithTooltip",
});
